import { AbstractReportPmsApiService } from '../abstract-report.service';
import { CashierReport } from '../../../models/reports/daily-activity/cashier.model';

/**
 * @class CashierReportPmsApiService
 * @extends {AbstractReportPmsApiService<CashierReport>}
 */
export class CashierReportPmsApiService extends AbstractReportPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return super.urlPattern + '/daily-activity/cashier';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {CashierReport}
     * @protected
     */
    newModel(attributes, ...params) {

        return new CashierReport(attributes);
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/reports/daily-activity/cashier.service.js